import * as React from 'react';
import { CurrencyContext, LocaleContext, consumer } from '@tock/coretypes';
import { IntlProvider } from 'react-intl';
import { Theme, css } from '@emotion/react';
import AvailabilitySearchResultsMapResult from 'components/www/availability-search/AvailabilitySearchResultsMapResult';
import Slider, { Settings } from 'react-slick';

const overall = ({ spacing, zIndex }: Theme) => css`
  position: absolute;
  z-index: ${zIndex.drawer};
  background-color: transparent;
  padding-top: ${spacing(2)}px;
  padding-bottom: ${spacing(2)}px;
  bottom: 0;
  overflow: hidden;
  width: 100vw;
`;

const slide = ({ spacing }: Theme) => css`
  padding-left: ${spacing(1)}px;
  padding-right: ${spacing(1)}px;
`;

interface Props {
  results?: consumer.BusinessAvailabilitySearchResponse;
  selectedBusinessId?: number;
  handleSlideChange(currentSlide: number): void;
  onBookNow(result: consumer.ISearchOfferingBusiness): void;
}

const AvailabilitySearchResultsMapResults: React.FunctionComponent<Props> = ({
  results,
  selectedBusinessId,
  handleSlideChange,
  onBookNow,
}) => {
  const slider = React.useRef<Slider>();

  React.useEffect(() => {
    if (results && results.offeringAvailability.length > 0) {
      const index = results.offeringAvailability.findIndex(
        (result) => result.business?.id === selectedBusinessId
      );
      if (index !== -1) {
        slider.current?.slickGoTo(index);
      }
    }
  }, [selectedBusinessId, results]);

  const handleAfterChange = (currentSlide: number) => {
    handleSlideChange(currentSlide);
  };

  const settings: Settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: '20px',
    lazyLoad: 'progressive',
    afterChange: handleAfterChange,
  };
  return (
    <div css={overall}>
      <Slider ref={(c) => (slider.current = c as Slider | undefined)} {...settings}>
        {results &&
          results.offeringAvailability.length > 0 &&
          results.offeringAvailability.map((result) => {
            const business = result.business as consumer.OfferingBusiness;

            return (
              <IntlProvider key={business.id} locale={business.locale}>
                <LocaleContext.Provider value={business.locale}>
                  <CurrencyContext.Provider value={business.currencyCode}>
                    <div css={slide}>
                      <AvailabilitySearchResultsMapResult
                        onBookNow={() => onBookNow(result)}
                        business={business}
                      />
                    </div>
                  </CurrencyContext.Provider>
                </LocaleContext.Provider>
              </IntlProvider>
            );
          })}
      </Slider>
    </div>
  );
};

export default AvailabilitySearchResultsMapResults;
